import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "role-card-resumes"
};
const _hoisted_2 = {
  class: "group-container"
};
const _hoisted_3 = {
  key: 0,
  class: "empty-data-container"
};
const _hoisted_4 = {
  key: 1,
  class: "data-container"
};
const _hoisted_5 = {
  key: 2,
  class: "pagination-container"
};
import { onMounted, ref, watch } from 'vue';
import { ElRow } from 'element-plus';
import DramaPerformance from '@/components/Common/DramaPerformance.vue';
import { request } from '@/manager/net_manager';
import { List } from "@element-plus/icons-vue";
export default {
  __name: 'RoleCardResumes',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    }
  },

  setup(__props) {
    const props = __props;
    const dataArray = ref([]);
    const pagerCount = ref(5);
    const size = ref(10);
    const total = ref(0);
    const page = ref(1);
    onMounted(() => {
      getData();
    });

    const getData = () => {
      let parameters = {};
      parameters['role_id'] = props.roleId;
      parameters['page'] = page.value - 1;
      parameters['size'] = size.value; // console.log(JSON.stringify(parameters))

      request('role/role_resumes/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          dataArray.value = response.data.resumes;
          total.value = response.data.numbers;
        }
      });
    };

    const handlePageChange = index => {
      page.value = index;
      getData();
    }; // watcher


    watch(() => props.roleId, () => {
      page.value = 1;
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(List))]),
            _: 1
          }), _cache[0] || (_cache[0] = _createElementVNode("text", {
            class: "group-title"
          }, "演出履历", -1))]),
          _: 1
        })]),
        _: 1
      }), dataArray.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [_createElementVNode("text", {
        class: "empty-data-tips"
      }, "未发现演出数据", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(DramaPerformance, {
        dataArray: dataArray.value,
        "role-id": __props.roleId
      }, null, 8, ["dataArray", "role-id"])])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        "current-page": page.value,
        onCurrentChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total", "current-page"])])) : _createCommentVNode("", true)])]);
    };
  }

};